import { XCircle } from "lucide-react";

interface UseCaseProblemsProps {
  problems: string[];
  accentColor: string;
}

const UseCaseProblems = ({ problems, accentColor }: UseCaseProblemsProps) => {
  return (
    <section className="relative py-20 lg:py-24 bg-[#0A0A0F]">
      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-12 animate-fade-up">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-1 w-8 rounded-full bg-[#EF4444]" />
              <span className="text-sm font-medium uppercase tracking-wider text-white/50">
                Les probl&egrave;mes
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Avant B<span style={{ color: accentColor }}>8</span>ild
            </h2>
          </div>

          {/* Problems grid */}
          <div className="grid gap-4 sm:grid-cols-2">
            {problems.map((problem, index) => (
              <div
                key={index}
                className="group relative rounded-xl p-[1px] bg-gradient-to-b from-[#EF4444]/20 to-transparent animate-fade-up hover:from-[#EF4444]/30 transition-all duration-300"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="rounded-xl bg-[#0F0F14]/80 backdrop-blur-xl p-5 h-full">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-[#EF4444]/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <XCircle className="h-5 w-5 text-[#EF4444]" />
                    </div>
                    <p className="text-white/70 leading-relaxed pt-1.5">
                      {problem}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseProblems;
